import {
  ApiResListsType,
  ApiResponseType,
  OhsApiRequestName,
  OhsApiRequestOptions,
  RequestType,
} from 'global-services/api/OhsApiModels';
import OhsApiRequest from 'global-services/api/OhsApiRequest';
import { ModuleType } from 'global-services/constants/OhsObject';
import { OhsAllocationItem } from 'global-components/allocation/OhsAllocatableModels';
import { getCurrentTimezone } from 'global-services/OhsDataParse';

import { OhsQrCodeListsFilterPayload, QrCodeAllocListRes } from './models/OhsQrCodeModels';
import OhsQrCodeRecord from './models/OhsQrCodeRecord';

export const addQrCode = (payload: any, options?: OhsApiRequestOptions) => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.QrCode,
    OhsApiRequestName.Create,
    payload,
    options
  );
};

export const editQrCode = (payload: any, options?: OhsApiRequestOptions) => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.QrCode,
    OhsApiRequestName.Edit,
    payload,
    options
  );
};

export const getQrCodeLists = (
  filterInfo: OhsQrCodeListsFilterPayload
): Promise<ApiResListsType<OhsQrCodeRecord[]> | null> => {
  return OhsApiRequest(RequestType.Module, ModuleType.QrCode, OhsApiRequestName.List, {
    filter: filterInfo,
  });
};

export const getQrCodeDetails = async (
  _id: string,
  disableErrorToast?: boolean
): Promise<OhsQrCodeRecord> => {
  const res: OhsQrCodeRecord | null = await OhsApiRequest(
    RequestType.Module,
    ModuleType.QrCode,
    OhsApiRequestName.Fetch,
    { _id },
    { disableErrorToast }
  );
  return res || new OhsQrCodeRecord();
};

export const setEnableDisableQrCode = async (_id: string, isEnabled: boolean): Promise<any> => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.QrCode,
    isEnabled ? OhsApiRequestName.Disable : OhsApiRequestName.Enable,
    {
      _id,
    }
  );
};

export const archiveUnarchiveQrCode = (qrCodeId: string, archived: boolean) => {
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.QrCode,
    archived ? OhsApiRequestName.Archive : OhsApiRequestName.UnArchive,
    {
      _id: qrCodeId,
    }
  );
};

export const deleteQrCode = (qrCodeId: string) => {
  return OhsApiRequest(RequestType.Module, ModuleType.QrCode, OhsApiRequestName.Delete, {
    _id: qrCodeId,
  });
};

export const getQrCodeAllocationList = (
  qrCodeId: string
): Promise<ApiResponseType<QrCodeAllocListRes> | null> => {
  return OhsApiRequest(RequestType.Module, ModuleType.QrCode, OhsApiRequestName.AllocationList, {
    _id: qrCodeId,
  });
};

export const allocateQrCode = (
  _id: string,
  allocationItem: OhsAllocationItem | OhsAllocationItem[],
  options?: OhsApiRequestOptions
): Promise<any> => {
  const payload: any = { _id, to: [], tzDateCreated: getCurrentTimezone() };
  if (Array.isArray(allocationItem)) {
    payload.to = allocationItem.map((item) => ({
      _id: item._id,
      type: item.type,
    }));
  } else {
    payload.to = [allocationItem];
  }
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.QrCode,
    OhsApiRequestName.Allocate,
    payload,
    options
  );
};

export const deAllocateQrCode = (
  _id: string,
  allocationItem: OhsAllocationItem | OhsAllocationItem[]
): Promise<any> => {
  const payload: any = { _id, to: [], tzDateCreated: getCurrentTimezone() };
  if (Array.isArray(allocationItem)) {
    payload.to = allocationItem.map((item) => ({
      _id: item._id,
      type: item.type,
    }));
  } else {
    payload.to = [allocationItem];
  }
  return OhsApiRequest(
    RequestType.Module,
    ModuleType.QrCode,
    OhsApiRequestName.Deallocate,
    payload
  );
};

export const getQrCodeAllocatedList = (
  qrCodeListIDs: string[]
): Promise<OhsQrCodeRecord[] | null> => {
  return OhsApiRequest(RequestType.Module, ModuleType.QrCode, OhsApiRequestName.AllocatedList, {
    _ids: qrCodeListIDs,
  });
};
